import { Injectable, NgModule} from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { AuthService } from './services/auth.service';
import {Observable} from 'rxjs';
import { Builder } from 'protractor';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(public auth: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token = this.auth.getToken();

    if (token) {
   
      request = request.clone({
        setHeaders: {
        'Content-type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${token}`
        }
      });
    } else {
    request = request.clone({
      setHeaders: {
       Authorization: 'Basic ' + btoa('security:secret'),
      //  'Basic ' + btoa('opendata_cl_id_nopd:open_secret_encrypt_nopd')
       'Content-type': 'application/x-www-form-urlencoded'
      }
    });
    }

    return next.handle(request);
  }
}
